import { DateTime } from 'luxon';
import { TypeUtils } from '../../common/misc';
import { Utils } from '../../custom_shared/misc';
import { DataType } from '../types';

type PickerMomentLike = {
    format: (pattern: string) => string;
};

export default class InputUtils {
    static areValuesEqual(dataType: DataType, firstValue: unknown, secondValue: unknown): boolean {
        if (dataType === 'DateTime') {
            const normalizedFirstValue = Utils.convertDateValueToPickerValue(firstValue);
            const normalizedSecondValue = Utils.convertDateValueToPickerValue(secondValue);

            if (TypeUtils.hasLegacyMomentShape(normalizedFirstValue) && TypeUtils.hasLegacyMomentShape(normalizedSecondValue)) {
                return (normalizedFirstValue as PickerMomentLike).format('YYYY-MM-DD') ===
                    (normalizedSecondValue as PickerMomentLike).format('YYYY-MM-DD');
            }
        }

        if (dataType === 'DateTime' && TypeUtils.isDate(firstValue) && TypeUtils.isDate(secondValue)) {
            const firstDate = DateTime.fromJSDate(new Date(firstValue));
            const secondDate = DateTime.fromJSDate(new Date(secondValue));

            if (!firstDate.isValid || !secondDate.isValid) {
                return false;
            }

            return firstDate.startOf('day').toMillis() === secondDate.startOf('day').toMillis();
        }

        const bothAreStringArrays = TypeUtils.isStringArray(firstValue) && TypeUtils.isStringArray(secondValue);

        if (!bothAreStringArrays) {
            return firstValue === secondValue;
        }

        if (firstValue.length !== secondValue.length) {
            return false;
        }

        const sortedFirst = [...firstValue].sort();
        const sortedSecond = [...secondValue].sort();

        return sortedFirst.every((value, index) => value === sortedSecond[index]);
    }
}
